/* Berbénor ™ — shared behaviour (CTA scroll, video, sliders) */
(function(){
  if(window.__brbInit)return; window.__brbInit=true;

  // --- CTA scroll to native product buy-box quantity/variant selector ---
  function findBuyTarget(){
    // the bundle offer IS the quantity/pack selector now — scroll there
    var offer=document.querySelector('.brb-offer-h')||document.querySelector('.brb-tiers')||document.querySelector('.brb-offer-move');
    if(offer) return offer;
    var main=document.querySelector('[id*="__main"]')||document.querySelector('.shopify-section');
    if(!main) return null;
    var sels=['.product-form__buttons','buy-buttons','.price'];
    for(var i=0;i<sels.length;i++){var el=main.querySelector(sels[i]); if(el) return el;}
    return main;
  }
  function brbScroll(e){
    if(e){e.preventDefault();}
    var t=findBuyTarget();
    if(t){t.scrollIntoView({behavior:'smooth',block:'center'});}
    else{window.scrollTo({top:0,behavior:'smooth'});}
  }
  function bindCTAs(){
    document.querySelectorAll('[data-brb-scroll]').forEach(function(b){
      if(b.__brb)return; b.__brb=1; b.addEventListener('click',brbScroll);
    });
  }

  // --- S08 video play on tap ---
  function bindVideos(){
    document.querySelectorAll('.brb-s08 .brb-play').forEach(function(btn){
      if(btn.__brb)return; btn.__brb=1;
      btn.addEventListener('click',function(){
        var card=btn.closest('.brb-vcard'); var v=card&&card.querySelector('video');
        if(!v)return;
        // pause others
        document.querySelectorAll('.brb-s08 video').forEach(function(o){if(o!==v){o.pause();}});
        if(v.paused){v.play();btn.style.display='none';v.setAttribute('controls','');}
      });
      var card=btn.closest('.brb-vcard'); var v=card&&card.querySelector('video');
      if(v){v.addEventListener('pause',function(){btn.style.display='flex';});
            v.addEventListener('play',function(){btn.style.display='none';});}
    });
  }

  // --- slider dot sync (s08 video row) ---
  function bindDots(){
    document.querySelectorAll('.brb-s08').forEach(function(sec){
      var row=sec.querySelector('.brb-vrow'); var dots=sec.querySelectorAll('.brb-dots i');
      if(!row||!dots.length||row.__brb)return; row.__brb=1;
      row.addEventListener('scroll',function(){
        var i=Math.round(row.scrollLeft/(row.scrollWidth/dots.length));
        dots.forEach(function(d,j){d.classList.toggle('on',j===Math.min(i,dots.length-1));});
      },{passive:true});
    });
  }

  // --- s11 testimonials nav ---
  function bindTnav(){
    document.querySelectorAll('.brb-s11').forEach(function(sec){
      var row=sec.querySelector('.brb-trow');
      var prev=sec.querySelector('[data-brb-prev]'); var next=sec.querySelector('[data-brb-next]');
      var cur=sec.querySelector('[data-brb-cur]'); var cards=sec.querySelectorAll('.brb-tcard');
      if(!row||row.__brb)return; row.__brb=1;
      function step(d){var w=row.querySelector('.brb-tcard').offsetWidth+16;row.scrollBy({left:d*w,behavior:'smooth'});}
      if(prev)prev.addEventListener('click',function(){step(-1);});
      if(next)next.addEventListener('click',function(){step(1);});
      if(cur&&cards.length){row.addEventListener('scroll',function(){
        var i=Math.round(row.scrollLeft/(row.querySelector('.brb-tcard').offsetWidth+16));
        cur.textContent=Math.min(i+1,cards.length);
      },{passive:true});}
    });
  }

  // --- re-skin native buy-box buttons to maroon ---
  // The theme's custom-button component re-paints green inline, so we
  // set it robustly and watch each button's style/class to re-apply.
  var BRB_MAROON='rgb(139, 26, 43)';
  function paintBtn(b){
    if(b.__brbPainting)return;
    if(getComputedStyle(b).backgroundColor===BRB_MAROON && b.style.getPropertyPriority('background-color')==='important')return;
    b.__brbPainting=true;
    b.style.setProperty('background-color','#8B1A2B','important');
    b.style.setProperty('background-image','none','important');
    b.style.setProperty('transition','none','important');
    b.style.setProperty('color','#fff','important');
    b.style.setProperty('border-color','#8B1A2B','important');
    b.__brbPainting=false;
  }
  function buyBtns(){
    var main=document.querySelector('[id*="__main"]'); if(!main)return [];
    return [].slice.call(main.querySelectorAll('.add-to-cart-button,.sticky-add-to-cart__button,.button-custom,.shopify-payment-button__button--unbranded'));
  }
  function skinBuyBox(){buyBtns().forEach(paintBtn);}
  function watchButtons(){
    buyBtns().forEach(function(b){
      if(b.__brbWatch)return; b.__brbWatch=1;
      try{new MutationObserver(function(){paintBtn(b);}).observe(b,{attributes:true,attributeFilter:['style','class']});}catch(e){}
    });
  }

  // When a section is edited in the theme customizer it re-renders, creating a
  // SECOND copy of a moved block. Keep the freshly-rendered copy (the one still in
  // its own section wrapper, i.e. NOT already inside __main) and drop the stale one.
  function brbPickFresh(sel){
    var nodes=[].slice.call(document.querySelectorAll(sel));
    if(nodes.length<=1) return nodes[0]||null;
    var fresh=null;
    for(var i=0;i<nodes.length;i++){ if(!nodes[i].closest('[id*="__main"]')){ fresh=nodes[i]; break; } }
    if(!fresh) fresh=nodes[nodes.length-1];
    nodes.forEach(function(n){ if(n!==fresh && n.parentNode) n.parentNode.removeChild(n); });
    return fresh;
  }

  // --- relocate hero (rating+title+bullets) to top of product-info column ---
  function relocateHero(){
    var main=document.querySelector('[id*="__main"]'); if(!main)return;
    var hero=brbPickFresh('.brb-hero-move'); if(!hero)return;
    var titleBlock=main.querySelector('.lp-title');
    var info=titleBlock?titleBlock.parentElement:null;
    if(!info)return;
    if(hero.parentElement===info && hero===info.firstElementChild) return;
    info.insertBefore(hero, info.firstElementChild);
  }

  // --- relocate trust block (badges+review+shipping+accordion) under the buy button ---
  // Resilient: variant/qty changes re-render the buy region & can destroy the moved
  // node, so we keep its HTML and re-create it if it vanishes.
  var brbTrustHTML=null;
  function relocateTrust(){
    var main=document.querySelector('[id*="__main"]'); if(!main)return;
    var titleBlock=main.querySelector('.lp-title');
    var info=titleBlock?titleBlock.parentElement:null; if(!info)return;
    var buy=[].slice.call(info.children).filter(function(c){return /buy-buttons/.test(c.className);})[0];
    if(!buy)return;
    var trust=brbPickFresh('.brb-trust-move');
    if(trust && !brbTrustHTML) brbTrustHTML=trust.outerHTML;
    if(!trust && brbTrustHTML){ var tmp=document.createElement('div'); tmp.innerHTML=brbTrustHTML; trust=tmp.firstElementChild; }
    if(!trust)return;
    if(trust.parentElement===info && trust.previousElementSibling===buy) return;
    buy.insertAdjacentElement('afterend', trust);
  }

  // --- bundle offer: relocate into buy-box + drive quantity + button price ---
  function relocateOffer(){
    var main=document.querySelector('[id*="__main"]'); if(!main)return;
    var offer=brbPickFresh('.brb-offer-move'); if(!offer)return;
    var titleBlock=main.querySelector('.lp-title');
    var info=titleBlock?titleBlock.parentElement:null; if(!info)return;
    var buy=[].slice.call(info.children).filter(function(c){return /buy-buttons/.test(c.className);})[0];
    if(!buy)return;
    if(offer.nextElementSibling===buy) return;
    info.insertBefore(offer, buy);
  }
  function brbSetQty(n){
    var main=document.querySelector('[id*="__main"]'); if(!main)return;
    // set value only (dispatching change makes the theme re-render & destroy injected nodes)
    main.querySelectorAll('input[name="quantity"]').forEach(function(inp){ if(inp.value!=n) inp.value=n; });
  }
  var brbCurPrice='';
  function brbSetAtcPrice(price){
    brbCurPrice=price;
    var want=' | '+price;
    // only the MAIN add-to-cart button gets the price suffix (not the sticky one)
    document.querySelectorAll('[id*="__main"] .add-to-cart-button:not(.sticky-add-to-cart__button)').forEach(function(b){
      var suf=b.querySelector('.brb-atc-suffix');
      if(!suf){suf=document.createElement('span');suf.className='brb-atc-suffix';b.appendChild(suf);}
      if(suf.textContent!==want) suf.textContent=want;  /* idempotent: avoid observer loop */
    });
  }

  // --- sticky bar button → "Choisir mon offre ↑" pill that scrolls to the offer ---
  function stickyOffer(){
    var main=document.querySelector('[id*="__main"]'); if(!main)return;
    var b=main.querySelector('.sticky-add-to-cart__button'); if(!b)return;
    if(b.getAttribute('data-brb-sticky')!=='1'){
      b.setAttribute('data-brb-sticky','1');
      b.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation)e.stopImmediatePropagation();
        var tgt=document.querySelector('.brb-offer-h')||document.querySelector('.brb-tiers')||document.querySelector('.brb-offer-move')||main;
        if(tgt) tgt.scrollIntoView({behavior:'smooth',block:'start'});
      }, true);
    }
    // label + pill styling are done in CSS via [data-brb-sticky="1"] so we DON'T
    // remove the button's children (the theme needs its ref="quantityDisplay" child)
    var bar=b.closest('[class*="sticky-add-to-cart__bar"]')||b.parentElement;
    if(bar){
      var variant=bar.querySelector('.sticky-add-to-cart__variant');
      if(variant && variant.style.display!=='none') variant.style.setProperty('display','none','important');
      var img=bar.querySelector('.sticky-add-to-cart__image-img')||bar.querySelector('img');
      var ref=document.querySelector('.brb-tier-thumbs img');
      if(img && ref && (img.src||'').indexOf('brb-sticky')<0){
        var u=(ref.currentSrc||ref.src).replace(/brb-pack\d\.png/, 'brb-sticky.png');
        if(u.indexOf('brb-sticky.png')>=0){
          img.setAttribute('loading','eager'); img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.style.setProperty('object-fit','contain','important');
          img.src=u;
        }
      }
    }
  }
  function selectTier(tier){
    var tiers=[].slice.call(document.querySelectorAll('[data-brb-tier]'));
    tiers.forEach(function(t){t.classList.toggle('is-sel',t===tier);});
    var r=tier.querySelector('input[type=radio]'); if(r)r.checked=true;
    // drive the native variant (pack) radio by tier index → updates ALL buy buttons
    var qty=Number(tier.getAttribute('data-qty'))||1;
    var main=document.querySelector('[id*="__main"]');
    if(main){
      var vradios=main.querySelectorAll('variant-picker input[type="radio"]');
      if(vradios[0] && !vradios[0].checked){
        vradios[0].checked=true;
        var lbl=vradios[0].closest('label')||vradios[0];
        lbl.click();  /* real click fires the theme's variant-change flow reliably */
        vradios[0].dispatchEvent(new Event('change',{bubbles:true}));
      }
      // belt & suspenders: also set the form variant id directly for the ATC form
      var idInp=main.querySelector('input[name="id"]'); var vid=tier.getAttribute('data-variant');
      if(idInp && vid){ idInp.value=vid; }
    }
    brbSetQty(qty);  /* real number of individual bottles */
    brbSetAtcPrice(tier.getAttribute('data-price')||'');
  }
  function initTiers(){
    var tiers=document.querySelectorAll('[data-brb-tier]'); if(!tiers.length)return;
    var sel=null;
    tiers.forEach(function(t){
      if(!t.__brb){t.__brb=1; t.addEventListener('click',function(){selectTier(t);});}
      if(t.getAttribute('data-default')) sel=t;
    });
    var selected=document.querySelector('[data-brb-tier].is-sel');
    if(!selected) selectTier(sel||tiers[0]);
    else brbSetQty(Number(selected.getAttribute('data-qty'))||1);
  }

  function init(){bindCTAs();bindVideos();bindDots();bindTnav();relocateHero();relocateOffer();relocateTrust();skinBuyBox();watchButtons();initTiers();stickyOffer();if(brbCurPrice)brbSetAtcPrice(brbCurPrice);
    [100,300,800,1600].forEach(function(t){setTimeout(function(){relocateHero();relocateOffer();relocateTrust();skinBuyBox();watchButtons();initTiers();stickyOffer();if(brbCurPrice)brbSetAtcPrice(brbCurPrice);},t);});
    [150,400,900,1800].forEach(function(t){setTimeout(function(){skinBuyBox();watchButtons();},t);});
    var main=document.querySelector('[id*="__main"]');
    if(main&&!main.__brbObs){main.__brbObs=1;
      try{new MutationObserver(function(){relocateHero();relocateOffer();relocateTrust();skinBuyBox();watchButtons();initTiers();stickyOffer();if(brbCurPrice)brbSetAtcPrice(brbCurPrice);}).observe(main,{childList:true,subtree:true});}catch(e){}
    }
  }
  if(document.readyState!=='loading')init();
  else document.addEventListener('DOMContentLoaded',init);
  // Re-run on EVERY theme-customizer edit event so editing a block never leaves a
  // stale/duplicated copy or an empty gap (brbPickFresh dedupes; relocations re-place).
  ['shopify:section:load','shopify:section:unload','shopify:section:select',
   'shopify:section:deselect','shopify:section:reorder','shopify:block:select',
   'shopify:block:deselect'].forEach(function(ev){
    document.addEventListener(ev,function(){ init(); setTimeout(init,120); });
  });
})();
